import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'com.alulatechnologies.vivascore.healthwithheart',
  appName: 'Health with Heart',
  webDir: 'www/browser',
  loggingBehavior: 'production',

  server: {
    errorPath: '/'
  },
  plugins: {
    SplashScreen: {
      launchAutoHide: true,
      launchShowDuration: 10000,
      androidSplashResourceName: "splash",
      androidScaleType: "CENTER_CROP",
      backgroundColor: "#ffffff",
      splashFullScreen: true,
      splashImmersive: true,
      useDialog: false
    },
    Keyboard: {
      resizeOnFullScreen: true   // 👈 important for Android
    }
  },

  ios: {
    scheme: 'healthwithheart',
    handleApplicationNotifications: false
  },

  android: {
    flavor: 'healthwithheart',
    loggingBehavior: 'none'
  }
};

export default config;
